import { render, staticRenderFns } from "./modalCategory.vue?vue&type=template&id=b1976cb4"
import script from "./modalCategory.vue?vue&type=script&lang=js"
export * from "./modalCategory.vue?vue&type=script&lang=js"
import style0 from "./modalCategory.vue?vue&type=style&index=0&id=b1976cb4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports